module.exports = __webpack_public_path__ + "img/bonardptt.4a1703fd.png";